const regex = /filename="([^"]+)"/;

export const extractFileName = (
  contentDisposition: string | undefined
): string | undefined => {
  if (!contentDisposition) {
    return undefined;
  } else if (contentDisposition.startsWith("attachment")) {
    const match = regex.exec(contentDisposition);
    if (!match) {
      return undefined;
    } else if (match != null && match[1]) {
      return match[1];
    }
  }
};
